import { useState } from 'react';
export var usePopover = function usePopover() {
  var _useState = useState(false),
      popoverOpen = _useState[0],
      setPopoverOpen = _useState[1];

  var _useState2 = useState(null),
      popoverAnchorEl = _useState2[0],
      setPopoverAnchorEl = _useState2[1];
  /**
   * methods
   */


  var openPopoverAction = function openPopoverAction(event) {
    setPopoverOpen(true);
    setPopoverAnchorEl(event.currentTarget);
  };

  var closePopoverAction = function closePopoverAction() {
    setPopoverOpen(false);
    setPopoverAnchorEl(null);
  };

  return {
    popoverOpen: popoverOpen,
    popoverAnchorEl: popoverAnchorEl,
    setPopoverOpen: setPopoverOpen,
    setPopoverAnchorEl: setPopoverAnchorEl,
    openPopoverAction: openPopoverAction,
    closePopoverAction: closePopoverAction
  };
};